import {
    Calendar,
    CheckmarkIcon,
    ClockStopwatchIcon,
    CreditCardIcon,
    HomeIcon,
    SaleIcon,
} from '../../../../public/Images/financing';

export interface ValueProposition {
    Icon: any;
    text: string;
}

export const financingValuePropositions: ValueProposition[] = [
    { Icon: ClockStopwatchIcon, text: 'FinancingTutorialApproval' },
    {
        Icon: SaleIcon,
        text: 'FinancingTutorialInterestRate',
    },
    {
        Icon: CheckmarkIcon,
        text: 'FinancingTutorialCarInsurance',
    },
    {
        Icon: CreditCardIcon,
        text: 'FinancingTutorialLicenseRenewal',
    },
    {
        Icon: Calendar,
        text: 'FinancingTutorialEarlySettlement',
    },
    {
        Icon: HomeIcon,
        text: 'FinancingTutorialNoVisit',
    },
];
